import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { Organization } from '../../../OrganizationsTableContext'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<Organization>[] => {
  return [
    useNameColumn({
      help: HelpMessage.DesignSubmittals.Organizations.Name,
      width: 300,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Organization'),
  ]
}
